// extracted by mini-css-extract-plugin
export default {"form":"Account_form__Bv4xP","group":"Account_group__YLoWk","action":"Account_action__AmcGM"};